import React, { useRef } from "react";
import axios from "axios";
import * as constant from "../../global/const";
import auth from "../../Helpers/auth";
import getCacheBustingQuery from "../../Util/getCacheBustingQuery";
import noimage from "../../assets/images/base-1.png";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { TransparentLoader } from "../Loader/transparentLoader.component";
import OpcionesCategorias from "./opcionesCategorias.component";
import { OpcionesProductos } from "./opcionesProductos.component";
import { setCategories } from "../../Redux/actions/CategorieActions";

const CardOpciones = (props) => {
  const sucursal = useSelector((state) => state.page.sucursal);
  const dispatch = useDispatch();
  const updateCategories = (categories) => dispatch(setCategories(categories));
  const focusDiv = useRef(null);

  const [categoriasMarca, setCategoriasMarca] = useState([1, 0]);
  const [subCategoriaMarca, setSubCategoriaMarca] = useState([
    1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [principales, setPrincipales] = useState([]);
  const [lstProductos, setLstProductos] = useState([]);
  const [itemSelected, setItemSelected] = useState("");
  const [opcionPrincipal, setOpcionPrincipal] = useState("categoria_id");
  const [itemTitulo, setitemTitulo] = useState("");
  const {
    mostrarOpciones,
    setMostrarOpciones,
    categoriasGlobal = [],
    tipoCamino = 0,
  } = props;
  const [cancelClick, setCancelClick] = useState(true);
  const [loader, setLoader] = useState(true);
  const filtros = [{ id: 0, tipo: "" }];
  const [step, setStep] = useState(0);
  const myRef = useRef();
  let { history } = props;
  let user = JSON.parse(auth.getUsuario());

  const handleClickOutside = (event) => {
    const array = event.path || (event.composedPath && event.composedPath());
    const aux = array.filter(
      (p) => p.className && (p.className + "").includes("gridOptions")
    );
    const aux2 = array.filter(
      (p) => p.className == "gridOptions-second-aux-close"
    );
    const aux3 = array.filter(
      (p) => p.className && p.className + "" == "select-css aux"
    );

    if (aux2.length > 0) {
      setMostrarOpciones && setMostrarOpciones(false);
    }

    if (!aux.length > 0 && aux3.length == 0) {
      setMostrarOpciones && setMostrarOpciones(false);
    }
  };

  const handleOptionSelected = (e, prop, sectionC, pos = 0) => {
    if (typeof prop != "number") {
      setCategoriasMarca("Marcas" == prop ? [0, 1] : [1, 0]);

      //Si es un número, significa que se necesita consultar los productos de una catergoría
      setLoader(true);
      //La opción principal se usa para evitar que se vuelva a buscar una opción principal que ya este seleccionada
      if ("Marcas" == prop) {
        //Reinicio de todo
        setLstProductos([]);
        setPrincipales([]);
        setOpcionPrincipal("marca_id");

        getMarcas();
      } else if ("Categorias" == prop) {
        //Reinicio de todo
        setLstProductos([]);
        setPrincipales([]);
        setOpcionPrincipal("categoria_id");

        getCategoriasPrincipales();
      }
    } else {
      const aux = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      aux[pos] = 1;
      setSubCategoriaMarca(aux);
      getProductosCatalogo(
        prop,
        `?nit=${sucursal.nit}&codigo=${sucursal.codigo}&agencia=${sucursal.agencia}&${opcionPrincipal}=${prop}&orden=2&pagina=1&correo=${user.email}`
      );
    }
  };

  const updatePrincipals = (container) => {
    const lstButtons = document
      .querySelector(container)
      .querySelectorAll("button");
    lstButtons.forEach((button) => {
      button.className = "";
    });
    lstButtons[0].className = "selected";
  };
  //______Consulta__________
  const getCategoriasPrincipales = async () => {
    await axios
      .get(
        constant.GETCATEGORIAS +
          `?codigo=${sucursal.codigo}&nit=${sucursal.nit}&agencia=${sucursal.agencia}&correo=${user.email}`
      )
      .then((response) => {
        setSubCategoriaMarca([1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
        setPrincipales(response.data);
        updateCategories(response.data);
        setItemSelected(response.data[0].id + "");
        setitemTitulo(response.data[0].titulo);
        getProductosCatalogo(
          response.data[0].id,
          `?nit=${sucursal.nit}&codigo=${sucursal.codigo}&agencia=${sucursal.agencia}&categoria_id=${response.data[0].id}&orden=2&pagina=1&correo=${user.email}`
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getMarcas = async () => {
    await axios
      .get(
        constant.GETMARCAS +
          `?codigo=${sucursal.codigo}&nit=${sucursal.nit}&agencia=${sucursal.agencia}&correo=${user.email}`
      )
      .then((response) => {
        setPrincipales(response.data);
        setSubCategoriaMarca([1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);

        setItemSelected(response.data[0].id + "");
        setitemTitulo(response.data[0].titulo);
        updatePrincipals(".gridOptions-second");
        getProductosCatalogo(
          response.data[0].id,
          `?nit=${sucursal.nit}&codigo=${sucursal.codigo}&agencia=${sucursal.agencia}&marca_id=${response.data[0].id}&orden=2&pagina=1&correo=${user.email}`
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getProductosCatalogo = async (prop, consulta) => {
    setLoader(true);
    await axios
      .post(constant.GETPRODUCTOSCATALOGO + consulta, { filtros: filtros })
      .then((response) => {
        setLstProductos(response.data.productos.resultado);
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  useEffect(() => {
    if (sucursal) {
      //En caso de que se necesite sincronizar el llamado de consulta de las categorias
      if (tipoCamino == 1) {
        if (categoriasGlobal.length > 0 && principales.length == 0) {
          setPrincipales(categoriasGlobal);
          setItemSelected(categoriasGlobal[0].id + "");
          setitemTitulo(categoriasGlobal[0].titulo);
          getProductosCatalogo(
            categoriasGlobal[0].id,
            `?nit=${sucursal.nit}&codigo=${sucursal.codigo}&agencia=${sucursal.agencia}&categoria_id=${categoriasGlobal[0].id}&orden=2&pagina=1&correo=${user.email}`
          ).then(() => {
            setCancelClick(false);
          });
        }
      } else {
        getCategoriasPrincipales().then(() => {
          setCancelClick(false);
        });
      }
    }
  }, [sucursal, categoriasGlobal]);

  return (
    <div
      className={
        (step == 1
          ? "gridOptions primary"
          : step == 2
          ? "gridOptions primary secondary"
          : "gridOptions") + (mostrarOpciones ? " show" : " hide")
      }
      ref={myRef}
    >
      <div id="gridOptions-first" className="gridOptions-first" ref={focusDiv}>
        <button
          onClick={(e) => {
            setOpcionPrincipal("categoria_id");
            handleOptionSelected(e, "Categorias", ".gridOptions-first");
            step < 1 && setStep(1);
          }}
          className={
            (categoriasMarca[0] == 1 ? "selected " : "") +
            (cancelClick ? "unable" : "")
          }
        >
          <i className="fa fa-tag"></i>Categorías
        </button>

        <button
          onClick={(e) => {
            setOpcionPrincipal("marca_id");
            handleOptionSelected(e, "Marcas", ".gridOptions-first");
            step < 1 && setStep(1);
          }}
          className={
            (categoriasMarca[1] == 1 ? "selected " : "") +
            (cancelClick ? "unable" : "")
          }
        >
          <i className="far fa-star"></i>Marcas
        </button>
        <img
          className="gridOptions-first-img"
          src={`${constant.URL_BASE_IMAGES}Web/${
            "categoria_id" == opcionPrincipal ? "categorias" : "marcas"
          }/${itemSelected}.png?${getCacheBustingQuery(1)}`}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = noimage;
          }}
        ></img>
      </div>
      {/* Para completar las lineas */}
      <div className="gridOptions-second-aux">
        <i
          className="fa"
          aria-hidden="true"
          onClick={() => {
            setStep(step - 1);
          }}
        ></i>
        <div className="gridOptions-second-aux-close">
          <p>Cerrar</p>
          <div className="gridOptions-second-aux-close-circle">
            <i className="fa fa-times" aria-hidden="true"></i>
          </div>
        </div>
      </div>
      <OpcionesCategorias
        history={history}
        handleOptionSelected={handleOptionSelected}
        setItemSelected={setItemSelected}
        setitemTitulo={setitemTitulo}
        principales={principales}
        opcionPrincipal={opcionPrincipal}
        subCategoriaMarca={subCategoriaMarca}
        step={step}
        setStep={setStep}
      />
      {loader ? (
        <div className="gridOptions-third">
          <div>
            <TransparentLoader />
          </div>
        </div>
      ) : (
        <OpcionesProductos
          history={history}
          lstProductos={lstProductos}
          opcionPrincipal={opcionPrincipal}
          itemTitulo={itemTitulo}
          itemSelected={itemSelected}
          step={step}
          setStep={setStep}
        />
      )}
    </div>
  );
};
export default CardOpciones;
